import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useGetSectionTreeQuery,
  useSaveSectionsTreeMutation,
} from '../../../../../../redux/services/yellow_books';
import { useToastMessages } from '../../../../../../hooks/useToastMessages';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../../basic';
import { Spinner } from '../../../../../common';
import SectionsTree from './SectionsTree';

const SectionsOrderPage = () => {
  const { t } = useTranslation();
  const { yellowBookId } = useParams();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const {
    data: sections,
    isLoading,
    refetch,
  } = useGetSectionTreeQuery(yellowBookId);
  const [saveSectionsTree, { isSuccess: saveSuccess }] =
    useSaveSectionsTreeMutation(yellowBookId);

  useEffect(() => {
    document.title = t('Úprava poradia sekcií žltej knižky') + ' - FRI CMS';
  }, []); // Runs on mount

  useEffect(() => {
    if (saveSuccess) {
      showSaveSuccess();
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Úprava poradia sekcií žltej knižky')}
        backUrl={routes.cmsYellowBooksSections(yellowBookId)}
        backUrlTooltip={t('Žltá knižka')}
        permissionsBasic={'yellow-books'}
      />
      <SectionsTree
        sections={sections}
        onSave={(data) => saveSectionsTree({ data, yellowBookId })}
      />
    </>
  );
};

export default SectionsOrderPage;
